<template>
	<div class="bingliComp">
		<div class="tab">
			<div class="tabItem" :class="[curCaseNumber==item.caseNumber?'active':'']" @click="changeCurCaseNumber(item)" v-for="(item,index) in bingliList" :key="index">
				{{$public.FTime(item.caseDate,'MM-DD')}}
				<div v-if="item.oneSelf" style="text-align: center;font-size: 12px;background: #F56C6C;position: absolute;top: -6px;left: 40px;width: 18px;line-height: 18px;height: 18px;border-radius: 15px;color: white;">自</div>
			</div>
			<!-- <div class="tabItem">111</div> -->
		</div>
		<div class="con">
			<div class="conScroll">
				<div class="title">
					<div class="tit1">病情记录</div>
					<div class="tit2">{{$public.FTime(detail.createTime)}}</div>
					<div class="tit3" @click="leftSee">左侧展示</div>
				</div>
				<div class="line">
					<div class="item">
						<span style="color:#333336">账单金额：</span>
						<span style="display: inline-block;width:62px;">{{detail.totalMoney}}</span>
					</div>
					<div class="item">
						<span style="color:#333336">医生：</span>
						<span style="display: inline-block;width:62px;">{{detail.doctorName}}</span>
					</div>
				</div>
				<div class="line">
					<div class="item">
						<span style="color:#333336">体格检查：</span>
						<span style="display: inline-block;width:300px;">
							<span style="margin-right: 15px;">体重{{detail.weight||' -- '}}kg</span>
							<span style="margin-right: 15px;">体温{{detail.animalHeat||' -- '}}℃</span>
							<span style="margin-right: 15px;">呼吸{{detail.breatheRate||' -- '}}次/分</span>
							<span style="margin-right: 15px;">心率{{detail.heartRate||' -- '}}次/分</span>
						</span>
					</div>
				</div>
				<div class="line">
					<!-- <div class="item">
						<span style="color:#333336">病情等级：</span>
						<span style="display: inline-block;width:62px;">
							<span v-if="detail.conditionLevel===1">一般</span>
							<span v-if="detail.conditionLevel===2">急诊</span>
							<span v-if="detail.conditionLevel===3">危重</span>
							<span v-if="detail.conditionLevel===4">频危</span>
						</span>
					</div> -->
					<div class="item">
						<span style="color:#333336">康复情况：</span>
						<span style="display: inline-block;width:62px;">
							<span v-if="detail.completeState===1">治愈中</span>
							<span v-if="detail.completeState===2">已治愈</span>
							<span v-if="detail.completeState===3">死亡</span>
							<span v-if="detail.completeState===4">其它</span>
						</span>
					</div>
				</div>
				<div class="box">
					<div class="bingqing">
						<span style="font-weight: bold;">病情诊断：</span>
						<span style="color:#5E7BFA">
							<span v-for="(item1,index1) in detail.diagnosisTags" :key="index1">
								<span v-for="(item2,index2) in item1.symptom" :key="index2">
									<span v-for="(item3,index3) in item2.symptomLevel" :key="index3">
										{{item2.value}}-{{item3.value}} 
									</span>
								</span>
							</span>
						</span>
					</div>
					<div class="bingqing">
						<span style="font-weight: bold;">主诉：</span>
						{{detail.mainContent}}
					</div>
					<div class="bingqing">
						<span style="font-weight: bold;">临床检查：</span>
						{{detail.clinecContent}}
					</div>
					<div class="bingqing" style="border: 0;">
						<span style="font-weight: bold;">医嘱：</span>
						{{detail.doctorAdvice}}
					</div>
				</div>
				<div style="font-size: 14px;color:#333;padding:0 8px 0 8px;">
					挂号
				</div>
				<div class="box">
					<div class="bingqing">
						<span style="font-weight: bold;">门诊：{{detail.registrationRecordId}}</span>
						<!-- <span style="color:#5E7BFA">经办人 {{detail.registrationRecordId}}</span> -->
					</div>
					<div class="bingqing">
						<div class="table">
							<div class="tableRow">
								<div class="tableItem" style="width:200px;">1.{{guahaoDetail.goodsName}} {{guahaoDetail.skuValue}}</div>
								<div class="tableItem" style="width:140px;text-align: right;">1*{{(guahaoDetail.totalMoney||0).toFixed(2)}}元</div>
								<div class="tableItem" style="width:16px;">
									<div class="fu">付</div>
								</div>
							</div>
						</div>
					</div>
					<div class="bingqing" style="border:0;">
						<div class="total">合计金额：￥{{(guahaoDetail.totalMoney||0).toFixed(2)}}</div>
					</div>
				</div>
				<div style="font-size: 14px;color:#333;padding:0 8px 0 8px;">
					治疗方案
				</div>
				<div class="box" v-if="!$public.isNull(detail.inspectItem)">
					<div class="bingqing">
						<span style="font-weight: bold;">检测：</span>
						<!-- <span style="color:#5E7BFA">时间</span> -->
					</div>
					<div class="bingqing">
						<div class="table">
							<div class="tableRow" v-for="(item1,index1) in detail.inspectItem" :key="index1">
								<div class="tableItem" style="width:250px;">
									{{index1+1}}.{{item1.goodsName}}
								</div>
								<div class="tableItem" style="width:90px;text-align: right;">
									{{item1.allowWholesale===1?item1.num:item1.goodsDosage}}*
									{{(item1.price||0).toFixed(2)}}
									元
								</div>
								<div class="tableItem" style="width:16px;">
									<div class="fu">付</div>
								</div>
							</div>
						</div>
					</div>
					<div class="bingqing" style="border:0;">
						<div class="total">合计金额：￥{{totalMoney1.toFixed(2)}}</div>
					</div>
				</div>
				<div class="box" v-if="!$public.isNull(detail.recipelItem)">
					<div class="bingqing">
						<span style="font-weight: bold;">处方：</span>
						<!-- <span style="color:#5E7BFA">时间</span> -->
					</div>
					<div class="bingqing">
						<div class="table">
							<div class="tableRow" v-for="(item2,index2) in detail.recipelItem" :key="index2">
								<div class="tableItem" style="width:100px;">
									{{index2+1}}.{{item2.goodsName}}
								</div>
								<div class="tableItem" style="width:65px;">
									{{item2.skuValue}}
								</div>
								<div class="tableItem" style="width:85px;">
									<span v-if="!$public.isNull(item2.goodsUsage)">
										{{item2.goodsUsage[0]}}
										{{item2.goodsUsage[1]}}天{{item2.goodsUsage[2]}}次
										{{item2.goodsUsage[3]}}{{item2.goodsUsage[4]}}/次
									</span>
								</div>
								<div class="tableItem" style="width:90px;text-align: right;">
									{{item2.allowWholesale===1?item2.num:item2.goodsDosage}}*
									{{(item2.price||0).toFixed(2)}}
									元
								</div>
								<div class="tableItem" style="width:16px;">
									<div class="fu">付</div>
								</div>
							</div>
						</div>
					</div>
					<div class="bingqing" style="border:0;">
						<div class="total">合计金额：￥{{totalMoney2.toFixed(2)}}</div>
					</div>
				</div>
				<div class="box" v-if="!$public.isNull(detail.complicationItem)">
					<div class="bingqing">
						<span style="font-weight: bold;">并发症处方：</span>
						<!-- <span style="color:#5E7BFA">时间</span> -->
					</div>
					<div class="bingqing">
						<div class="table">
							<div class="tableRow" v-for="(item6,index6) in detail.complicationItem" :key="index6">
								<div class="tableItem" style="width:100px;">
									{{index6+1}}.{{item6.goodsName}}
								</div>
								<div class="tableItem" style="width:65px;">
									{{item6.skuValue}}
								</div>
								<div class="tableItem" style="width:85px;">
									<span v-if="!$public.isNull(item6.goodsUsage)">
										{{item6.goodsUsage[0]}}
										{{item6.goodsUsage[1]}}天{{item6.goodsUsage[2]}}次
										{{item6.goodsUsage[3]}}{{item6.goodsUsage[4]}}/次
									</span>
								</div>
								<div class="tableItem" style="width:90px;text-align: right;">
									{{item6.allowWholesale===1?item6.num:item6.goodsDosage}}*
									{{(item6.price||0).toFixed(2)}}
									元
								</div>
								<div class="tableItem" style="width:16px;">
									<div class="fu">付</div>
								</div>
							</div>
						</div>
					</div>
					<div class="bingqing" style="border:0;">
						<div class="total">合计金额：￥{{totalMoney6.toFixed(2)}}</div>
					</div>
				</div>
				<div class="box" v-if="!$public.isNull(detail.handleItem)">
					<div class="bingqing">
						<span style="font-weight: bold;">处置：</span>
						<!-- <span style="color:#5E7BFA">时间</span> -->
					</div>
					<div class="bingqing">
						<div class="table">
							<div class="tableRow" v-for="(item3,index3) in detail.handleItem" :key="index3">
								<div class="tableItem" style="width:250px;">
									{{index3+1}}.{{item3.goodsName}}
								</div>
								<div class="tableItem" style="width:90px;text-align: right;">
									{{item3.allowWholesale===1?item3.num:item3.goodsDosage}}*
									{{(item3.price||0).toFixed(2)}}
									元
								</div>
								<div class="tableItem" style="width:16px;">
									<div class="fu">付</div>
								</div>
							</div>
						</div>
					</div>
					<div class="bingqing" style="border:0;">
						<div class="total">合计金额：￥{{totalMoney3.toFixed(2)}}</div>
					</div>
				</div>
				<div class="box" v-if="!$public.isNull(detail.operationItem)">
					<div class="bingqing">
						<span style="font-weight: bold;">手术：</span>
						<!-- <span style="color:#5E7BFA">时间</span> -->
					</div>
					<div class="bingqing">
						<div class="table">
							<div class="tableRow" v-for="(item4,index4) in detail.operationItem" :key="index4">
								<div class="tableItem" style="width:250px;">
									{{index4+1}}.{{item4.goodsName}}
								</div>
								<div class="tableItem" style="width:90px;text-align: right;">
									{{item4.allowWholesale===1?item4.num:item4.goodsDosage}}*
									{{(item4.price||0).toFixed(2)}}
									元
								</div>
								<div class="tableItem" style="width:16px;">
									<div class="fu">付</div>
								</div>
							</div>
						</div>
					</div>
					<div class="bingqing" style="border:0;">
						<div class="total">合计金额：￥{{totalMoney4.toFixed(2)}}</div>
					</div>
				</div>
				<div class="box" v-if="!$public.isNull(detail.inHospitalItem)">
					<div class="bingqing">
						<span style="font-weight: bold;">住院：</span>
						<!-- <span style="color:#5E7BFA">时间</span> -->
					</div>
					<div class="bingqing">
						<div class="table">
							<div class="tableRow">
								<div class="tableItem" style="width:200px;">
									单号：{{curPetZhuyuanList.id}}
								</div>
							</div>
							<div class="tableRow">
								<div class="tableItem" style="width:256px;">
									住院时长：
									{{$public.FTime(curPetZhuyuanList.beginDate,'YYYY-MM-DD')}}{{$public.FTime(curPetZhuyuanList.endDate,'YYYY-MM-DD')}} |
									{{curPetZhuyuanList.caseInHospitalDuration}}
								</div>
								<div class="tableItem" style="width:80px;text-align: right;">
									{{detail.inHospitalItem[0].num}}*
									{{(detail.inHospitalItem[0].price||0).toFixed(2)}}
									元
								</div>
								<div class="tableItem" style="width:16px;">
									<div class="fu">付</div>
								</div>
							</div>
						</div>
					</div>
					<div class="bingqing" style="border:0;">
						<div class="total">合计金额：￥{{totalMoney5.toFixed(2)}}</div>
					</div>
				</div>
				<div class="box">
					<div class="bingqing">
						<span style="font-weight: bold;">回访：</span>
						<!-- <span style="color:#5E7BFA">{{$public.FTime(detail.visitDate)}}</span> -->
					</div>
					<div class="bingqing" style="border:0;">
						<div v-if="huifangHistoryList.length>0" class="table">
							<div class="tableRow" v-for="(huifangItem,huifangIndex) in huifangHistoryList" :key="huifangIndex">
								<div class="tableItem" style="width:130px;">{{$public.FTime(huifangItem.visitTime)}}</div>
								<div class="tableItem" style="width:216px;word-break: break-all;">{{huifangItem.visitContent}}</div>
							</div>
						</div>
						<div v-else style="font-size: 12px;line-height: 40px;text-align: center;">无回访记录</div>
					</div>
				</div>
				<div class="box">
					<div class="bingqing">
						<span style="font-weight: bold;">复诊：</span>
						<!-- <span style="color:#5E7BFA">{{$public.FTime(detail.againSeeDate)}}</span> -->
					</div>
					<div class="bingqing" style="border:0;">
						<div class="table">
							<div class="tableRow">
								<div class="tableItem" style="width:100%;">
									复诊时间：
									{{$public.isNull(detail.againSeeDate)?'- -':$public.FTime(detail.againSeeDate)}}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		data(){
			return{
				guahaoDetail:{},
				curPetZhuyuanList:{},
				
				curCaseNumber:'',
				detail:{},
				totalMoney1:0,
				totalMoney2:0,
				totalMoney3:0,
				totalMoney4:0,
				totalMoney5:0,
				totalMoney6:0,
				
				bingliList:[],
				// 回访列表
				huifangHistoryList:[],
			}
		},
		computed:{
			userInfo(){
				return this.$store.state.yiliaoxin.userInfo
			},
			curPetInfo(){
				let obj = this.$store.getters["yiliaoxin/curPetInfo"]
				return obj
			},
			bingliParams(){
				return this.$store.state.yiliaoxin.bingliParams;
			},
		},
		props:{
			initCaseNumber:{
				default:''
			}
		},
		watch:{
			curPetInfo(){
				this.getCurPetBingliList()
			}
		},
		created(){
			this.curCaseNumber = this.initCaseNumber
		},
		mounted(){
			this.getCurPetBingliList()
		},
		methods: {
			// 左侧展示
			leftSee(){
				this.bingliParams.curRow = this.detail;
				this.$store.commit("yiliaoxin/set_bingliParams",this.bingliParams)
			},
			// tab切换
			changeCurCaseNumber(item){
				this.getIllnessCase(item.caseNumber)
			},
			// 获取当前宠物病例列表
			getCurPetBingliList() {
				console.log(this.bingliParams.curRow.petId)
				if(this.$public.isNull(this.bingliParams.curRow.petId)){
					return ;
				}
				let params = {
					"departmentId":'', // -1:不限；1：内科；2：外科
					"departmentName":'', // -1:不限；1：内科；2：外科
					"petId": this.bingliParams.curRow.petId, 
					isPay:-1, // -1不限；0未支付；1已支付
					isInspect:-1,  // -1不限；0未检测；1已检测
					isVisit:-1,  // -1不限；0未回访；1已回访
					isEnter:-1,  
					showLater:false,
					"desc": false, // true  倒序  false 正序
					"begin_time": "",
					"end_time": "",
					"pageIndex": 1,
					"pageSize": 400,
					"keyword": ''
				}
				this.$http.post('/api/Case/List', params).then(res => {
					if (res.code == 0) {
						if(res.data.data){
							this.bingliList = res.data.data.sort((a,b)=>{return a.caseDate-b.caseDate});
							if(this.bingliList.length>0){
								this.getIllnessCase(this.curCaseNumber)
							}
						}
					}
				})
			},
			// 获取病例详情
			getIllnessCase(caseNumber) {
				let params = {
					"caseNumber": caseNumber,
					random:Math.random(), // 随机数
				}
				let loading = this.$loading()
				this.$http.get('/api/Case/Detail', params).then(res => {
					loading.close();
					if (res.code == 0) {
						res.data.inspectItem = (res.data.inspectItem||[]).filter(a=>{return a.isPay===true})
						res.data.recipelItem = (res.data.recipelItem||[]).filter(a=>{return a.isPay===true})
						res.data.handleItem = (res.data.handleItem||[]).filter(a=>{return a.isPay===true})
						res.data.operationItem = (res.data.operationItem||[]).filter(a=>{return a.isPay===true})
						res.data.inHospitalItem = (res.data.inHospitalItem||[]).filter(a=>{return a.isPay===true})
						res.data.complicationItem = (res.data.complicationItem||[]).filter(a=>{return a.isPay===true})
						this.detail = res.data;
						this.curCaseNumber = this.detail.caseNumber
						this.getTotalMoney()
						this.getGuahaoDetail()
						this.getHuifangHistory()
						if(this.detail.isCompleted==true){
							return ;
						}else{
							this.detail.inHospitalId&&this.getCurPetZhuyuanList(this.detail.inHospitalId)
						}
					}
				})
			},
			getTotalMoney(){
				let totalMoney1 = 0
				for(let i=0;i<this.detail.inspectItem.length;i++){
					if(this.detail.inspectItem[i].allowWholesale===1){
						totalMoney1 = this.$public.jia(totalMoney1,this.$public.cheng(this.detail.inspectItem[i].price,this.detail.inspectItem[i].num))
					}else{
						totalMoney1 = this.$public.jia(totalMoney1,this.$public.cheng(this.detail.inspectItem[i].price,this.detail.inspectItem[i].goodsDosage))
					}
				}
				let totalMoney2 = 0
				for(let i=0;i<this.detail.recipelItem.length;i++){
					if(this.detail.recipelItem[i].allowWholesale===1){
						totalMoney2 = this.$public.jia(totalMoney2,this.$public.cheng(this.detail.recipelItem[i].price,this.detail.recipelItem[i].num))
					}else{
						totalMoney2 = this.$public.jia(totalMoney2,this.$public.cheng(this.detail.recipelItem[i].price,this.detail.recipelItem[i].goodsDosage))
					}
					
				}
				let totalMoney3 = 0
				for(let i=0;i<this.detail.handleItem.length;i++){
					if(this.detail.handleItem[i].allowWholesale===1){
						totalMoney3 = this.$public.jia(totalMoney3,this.$public.cheng(this.detail.handleItem[i].price,this.detail.handleItem[i].num))
					}else{
						totalMoney3 = this.$public.jia(totalMoney3,this.$public.cheng(this.detail.handleItem[i].price,this.detail.handleItem[i].goodsDosage))
					}
					
				}
				let totalMoney4 = 0
				for(let i=0;i<this.detail.operationItem.length;i++){
					if(this.detail.operationItem[i].allowWholesale===1){
						totalMoney4 = this.$public.jia(totalMoney4,this.$public.cheng(this.detail.operationItem[i].price,this.detail.operationItem[i].num))
					}else{
						totalMoney4 = this.$public.jia(totalMoney4,this.$public.cheng(this.detail.operationItem[i].price,this.detail.operationItem[i].goodsDosage))
					}
					
				}
				let totalMoney5 = 0
				for(let i=0;i<this.detail.inHospitalItem.length;i++){
					if(this.detail.inHospitalItem[i].allowWholesale===1){
						totalMoney5 = this.$public.jia(totalMoney5,this.$public.cheng(this.detail.inHospitalItem[i].price,this.detail.inHospitalItem[i].num))
					}else{
						totalMoney5 = this.$public.jia(totalMoney5,this.$public.cheng(this.detail.inHospitalItem[i].price,this.detail.inHospitalItem[i].goodsDosage))
					}
					
				}
				let totalMoney6 = 0
				for(let i=0;i<this.detail.complicationItem.length;i++){
					if(this.detail.complicationItem[i].allowWholesale===1){
						totalMoney6 = this.$public.jia(totalMoney6,this.$public.cheng(this.detail.complicationItem[i].price,this.detail.complicationItem[i].num))
					}else{
						totalMoney6 = this.$public.jia(totalMoney6,this.$public.cheng(this.detail.complicationItem[i].price,this.detail.complicationItem[i].goodsDosage))
					}
					
				}
				this.totalMoney1 = totalMoney1
				this.totalMoney2 = totalMoney2
				this.totalMoney3 = totalMoney3
				this.totalMoney4 = totalMoney4
				this.totalMoney5 = totalMoney5
				this.totalMoney6 = totalMoney6
			},
			getGuahaoDetail(){
				if(this.$public.isNull(this.detail.registrationRecordId)){
					return ;
				}
				let params = {
					"recordId": this.detail.registrationRecordId,
				}
				this.$http.get('/api/Registration/Detail', params).then(res => {
					if (res.code == 0) {
						this.guahaoDetail = res.data;
					}
				})
			},
			getCurPetZhuyuanList(inHospitalId) {
				let params = {
					"inHospitalId": inHospitalId,
				}
				this.$http.get('/api/InHospital/Detail', params).then(res => {
					if (res.code == 0) {
						this.curPetZhuyuanList = res.data;
					}
				})
			},
			getHuifangHistory(){
				let params = {
					caseNumber:this.detail.caseNumber,
				}
				this.$http.get('/api/case/reply/list',params).then(res => {
					if(res.code===0){
						this.huifangHistoryList=res.data||[]
					}
				})
			},
		},
	}
</script>
<style scoped lang="scss">
	.bingliComp{
		padding:0 8px;width:100%;height: 100%;box-sizing: border-box;
		.tab{
			display: flex;flex-wrap: wrap;width:100%;
			.tabItem{
				font-size: 12px;color:#73737B;line-height: 22px;background-color: #F6F7FA;padding:0 12px;border-radius: 12px;margin:0 0 8px 8px;border:1px solid transparent;cursor: pointer;position: relative;
				&.active{
					border-color:#5E7BFA;color:#5E7BFA;background-color: #F3F8FF;
				}
			}
		}
		.con{
			background-color: #F3F6FF;height: calc(100% - 42px);border-radius: 3px;padding:8px;box-sizing: border-box;
			.conScroll{
				width:100%;height: 100%;overflow: auto;
				&::-webkit-scrollbar {
					width: 4px;
					// height: 4px;
				}
				
				.title{
					display: flex;padding-bottom:8px;
					.tit1{
						font-size: 14px;color:$fontColor;font-weight: bold;width:72px;
					}
					.tit2{
						font-size: 12px;color:#3E3E3E;width:243px;line-height: 14px;
					}
					.tit3{
						font-size: 12px;color:#5E7BFA;cursor: pointer;
					}
				}
				.line{
					display: flex;
					.item{
						font-size: 12px;color:#666;line-height: 17px;
					}
				}
				.box{
					font-size: 12px;padding:0 8px;box-sizing: border-box;border:1px solid #D6DCF6;border-radius: 3px;background-color: #fff;margin:8px 0;
					.bingqing{
						color:#73737B;line-height: 17px;border-bottom:1px solid #CBD2FE;padding:8px 0;
						.table{
							.tableRow{
								display: flex;padding:2px 0;
								.tableItem{
									font-size: 12px;color:#73737B;padding:0 3px;box-sizing: border-box;
									.fu{
										width:16px;height: 16px;line-height: 16px;text-align: center;color:#fff;background-color: #5E7BFA;border-radius: 1px;font-size: 12px;
									}
								}
							}
						}
						.total{
							text-align: right;
						}
					}
				}
			}
		}
	}
</style>
